import React from "react";
import { Stack } from "@mui/material";

import { JobsTable } from "../../tables";
import OrdersTableSwitch from "../../pages/Orders/OrdersTableSwitch";
import { ScheduleBarChart } from "../ScheduleBarChart";

import { StyledContainerStack, StyleTableCardStack } from "./styles";

export const Scheduler = () => {
  return (
    <StyledContainerStack>
      <ScheduleBarChart />
      <StyleTableCardStack>
        <OrdersTableSwitch />
      </StyleTableCardStack>
    </StyledContainerStack>
  );
};

export default Scheduler;
